import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { ETaxNote } from "../../../types/e-tax.type";
import { EXPIRED_TOOLTIP } from "../AutoSend/autoSendMeta";
import { tintedChipSx } from "../AutoSend/autoSendCells";
import { EtaxStatusBadge } from "../documentCells";
import { EXPIRED_STATUS_META } from "../documentMeta";
import { getNoteReasonLines } from "./noteSend";

/** Keeps a long reason on a few lines instead of widening the status column. */
const REASON_MAX_WIDTH = 280;

/** The width the status chips of the bill lists share, so the expired chip lines up with them. */
const STATUS_CHIP_MIN_WIDTH = 84;

/**
 * The note's e-Tax state in the bills' chip words, with the reasons it cannot be sent in plain
 * sight under it: a note waiting for its original bill, refused by KTB or from a closed tax month
 * is something the reader has to act on, so the reason is not left to a tooltip.
 */
export default function NoteStatusCell({ note }: Readonly<{ note: ETaxNote }>) {
  const reasonLines = getNoteReasonLines(note);

  return (
    <Stack alignItems="flex-start" gap={0.5}>
      {note.is_expired ? (
        <Tooltip arrow title={EXPIRED_TOOLTIP}>
          <Chip
            label={EXPIRED_STATUS_META.label}
            size="small"
            sx={{ ...tintedChipSx(EXPIRED_STATUS_META.color), minWidth: STATUS_CHIP_MIN_WIDTH }}
          />
        </Tooltip>
      ) : (
        <EtaxStatusBadge
          status={note.etax_status}
          eligible={note.can_send}
          documentStatus={note.document_status}
          isPaper={!note.etax_enabled}
        />
      )}
      {reasonLines.map((line) => (
        <Typography
          key={line}
          variant="caption"
          color="text.secondary"
          sx={{ maxWidth: REASON_MAX_WIDTH }}
        >
          {line}
        </Typography>
      ))}
    </Stack>
  );
}
